import {Component, Input, OnInit} from '@angular/core';
import {trackByValue} from '../../utils/track-by';

@Component({
    selector: 'vex-breadcrumbs',
    template: `
    <div class="flex items-center">
      <vex-breadcrumb>
        <a [routerLink]="['/']">
          <mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>
        </a>
      </vex-breadcrumb>
      <ng-container *ngFor="let crumb of crumbs; trackBy: trackByValue">
        <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"></div>
        <vex-breadcrumb>
          <a *ngIf="!isString(crumb)" [routerLink]="crumb.route">{{ crumb.label }}</a>
          <a *ngIf="isString(crumb)">{{ crumb }}</a>
        </vex-breadcrumb>
      </ng-container>
    </div>
  `,
    standalone: false
})
export class BreadcrumbsComponent implements OnInit {

  @Input() crumbs: any[] = [];

  trackByValue = trackByValue;

  constructor() {
  }

  ngOnInit() {
  }

  protected isString(item): boolean {
    return typeof item === 'string';
  }
}
